import { useInfiniteQuery } from '@tanstack/react-query';

import { ICatalogsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export interface IParams {
  limit: number;
}

export const useGetCatalogsQuery = ({ limit, tab }: ICatalogsParams) => {
  return useInfiniteQuery({
    queryKey: ['getCatalogs', limit, tab],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.products.getCatalogs({ offset: pageParam, limit, tab });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
